import React, { useState, useEffect, useLayoutEffect } from "react";
import Header from "../layout/header";
import HeaderProfile from "../layout/header-profile";
import Icon1 from "../images/icon1.png";
import Icon3 from "../images/icon3.png";
import Icon2 from "../images/icon2.png";
import Icon4 from "../images/Account-cash.png";
import Icon5 from "../images/dividends.png";
import Icon6 from "../images/Account-Realized-gain.png";
import Donutchart from "./donut-chart";
import Donutchart2 from "./donut-chart2";
import Barchart from "./barchart";
import HorizontalBarchart from "./horizontal-bar";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useNavigate } from 'react-router-dom';
import callingAPI from "../service"
import DashboardAccountInfo from "./dashboardAccountInfo"
import loadingImage from '../images/login-shape.png'
import { useLocation } from 'react-router-dom';
import Disclaimer from "./disclaimer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setDashboardData } from "../redux/reducers/dashboardSlice";


export default function Dashboard() {
    const dispatch = useDispatch();
    const dashboardDetails = useSelector((state) => state.Dashboard);
    console.log("🚀 ~ Dashboard ~ dashboardDetails:", dashboardDetails)
    const clientId = dashboardDetails.clientid
    const navigate = useNavigate();
    const [dashboardSummaryData, setDashboardSummaryData] = useState(dashboardDetails.dashBoardSummaryData ? dashboardDetails?.dashBoardSummaryData : [])
    const [dashboardAccountDataInfo, setDashboardAccountDataInfo] = useState(dashboardDetails.dashboardAccountDataInfo ? dashboardDetails?.dashboardAccountDataInfo : [])
    const [exchangeAllocationGraph, setExchangeAllocationGraph] = useState(dashboardDetails.exchangeAllocationGraph ? dashboardDetails?.exchangeAllocationGraph : [])
    const [sectorAllocationGraph, setSectorAllocationGraph] = useState(dashboardDetails.sectorAllocationGraph ? dashboardDetails?.sectorAllocationGraph : [])
    const [top5Dividends, setTop5Dividends] = useState(dashboardDetails.top5Dividends ? dashboardDetails?.top5Dividends : [])
    const [top5Holdings, setTop5Holdings] = useState(dashboardDetails.top5Holdings ? dashboardDetails?.top5Holdings : [])
    const [loaderFlag, setLoaderFlag] = useState(false)
    const sessionFromDate = dashboardDetails.fromDate;
    const currentDate = sessionFromDate ? new Date(sessionFromDate) : new Date();
    var formattedDate = new Date().toISOString().split('T')[0];
    const location = useLocation();
    var selectedDashboardDate = "";
    const [showDisclaimer, setShowDisclaimer] = useState(dashboardDetails.showDisclaimer ? dashboardDetails.showDisclaimer : "false")
    const [directFlag, setDirectFlag] = useState(null)
    const userId = dashboardDetails.userId
    const refreshToken = dashboardDetails.refreshToken;
    const marginFlag = dashboardDetails.marginFlag
    var userLogId = ""
    useEffect(() => {
        setLoaderFlag(false)
        dispatch(
            setDashboardData({
                moduleId: 1,
            })
        );
        handleAccountData()
        dashboardHandleChange()
        if (location.state) {
            setDirectFlag(location.state?.directFlag)
        }
        else {
            setDirectFlag(true)
        }
        handleUserLog()
    }, [location]);

    useLayoutEffect(() => {

        return () => {
            handleUserLog();
        };
    }, []);


    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 1,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 1,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    useEffect(() => {
        dispatch(setDashboardData({ reportValue: "Dashboard" })
        )

        formattedDate = currentDate.toISOString().split('T')[0];
        window.scrollTo(0, 0);
        if (!clientId) {
            navigate('/');
            return;
        }

    }, [])

    const dashboardHandleChange = () => {
        if (!clientId) {
            console.error('Client ID not found.');
            return;
        }
        const postData = {
            clientId: clientId,
            "userId": userId,
            //"refreshToken": refreshToken
        };
        callingAPI(postData, "user/dashboard", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    setDashboardSummaryData(data.data || []);
                    dispatch(
                        setDashboardData({
                            dashBoardSummaryData: data?.data || []
                        })
                    );
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    const handleAccountData = () => {
        dispatch(setDashboardData({ initialDate: "" }))
        const intialdate = dashboardDetails.initialDate
        const fromdate = dashboardDetails.porfolioDashDate
        const date = dashboardDetails.porfolioDashDate
        if (!clientId) {
            console.error('Client ID not found.');
            return;
        }
        const postData = {
            "userId": userId,
            "fromDate": date ? new Date(date).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0],
            "toDate": date ? new Date(date).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0],
            "externalAPI": dashboardDetails.externalAPI,
            "clientId": clientId,
            "marginFlag": marginFlag,
            //"refreshToken": refreshToken
        }
        callingAPI(postData, "reports/dashboard", 'post')
            .then((response) => {
                const { data } = response;
                dispatch(setDashboardData({ initialDate: new Date(dashboardDetails.porfolioDashDate).toString() })
                )
                console.log("🚀 ~ .then ~ data:", data)
                if (data.statusCode === 200) {
                    dispatch(setDashboardData({
                        dashboardAccountDataInfo: data?.data || [],
                        exchangeAllocationGraph: data.data?.exchangeAllocation || [],
                        sectorAllocationGraph: data.data?.sectorAllocation || [],
                        top5Dividends: data.data?.top5Dividends || [],
                        top5Holdings: data.data?.top5Holdings || [],
                        externalAPI: false
                    }))

                    setDashboardAccountDataInfo(data.data || []);
                    setExchangeAllocationGraph(data.data.exchangeAllocation || []);
                    setSectorAllocationGraph(data.data.sectorAllocation || []);
                    setTop5Dividends(data.data.top5Dividends || []);
                    setTop5Holdings(data.data.top5Holdings || []);
                    selectedDashboardDate = "";
                    formattedDate = "";
                    setTimeout(() => {
                        setLoaderFlag(true);  // Set loader to true after a delay
                    }, 1000);

                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    return (
        <div className="main-wrapper">
            <div className="top-outer">
                <Header />
                <HeaderProfile key={location.state} />
                {directFlag && dashboardDetails.showDisclaimer !== "true" &&
                    <div>
                        <Disclaimer />
                    </div>}
            </div>
            {loaderFlag ?
                <div className="main-outer">
                    <div className="row m-0 main-row">
                        <div className="col-12 col-lg-5 col-md-12 position-relative">

                            <div className="tabs-left p-2 p-xxl-3">
                                <div className="tab-square">
                                    <Tabs>
                                        <TabList>
                                            <Tab>Account Summary</Tab>
                                            <Tab>Relationship Manager</Tab>
                                        </TabList>
                                        <TabPanel>
                                            {dashboardSummaryData.accountDetails && dashboardSummaryData.accountDetails.map((data) => (
                                                <>
                                                    <div className="row ps-2 pb-lg-3 pb-sm-3 pb-0">
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                IA Number
                                                            </div>
                                                            <div className="formName">
                                                                {data.clientid}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Name
                                                            </div>
                                                            <div className="formName">
                                                                {data.clientName}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row ps-2">
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Report Date
                                                            </div>
                                                            <div className="formName">
                                                                {currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Reporting Currency
                                                            </div>
                                                            <div className="formName">
                                                                {data.bankcurrency}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </TabPanel>
                                        <TabPanel>
                                            {dashboardSummaryData.relationshipManager && dashboardSummaryData.relationshipManager.map((data) => (
                                                <>
                                                    <div className="row ps-2 pb-lg-3 pb-sm-3 pb-0">
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Name
                                                            </div>
                                                            <div className="formName">

                                                                {data.rname}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row ps-2">
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Telephone
                                                            </div>
                                                            <div className="formName">
                                                                {data.rmtelnumber}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-md-6 mb-2 mb-lg-0 mb-md-0">
                                                            <div className="formLabel">
                                                                Email
                                                            </div>
                                                            <div className="formName text-truncate" title={data.remail}>
                                                                {data.remail}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </TabPanel>
                                    </Tabs>
                                </div>

                                <div>

                                </div>
                            </div>

                        </div>
                        <div className="col-12 d-flex col-lg-7 col-md-12">
                            <DashboardAccountInfo key={dashboardAccountDataInfo} dashboardAccountDataInfo={dashboardAccountDataInfo} />
                        </div>
                    </div>
                    <div className="main-dashboard-wrap pt-1">
                        <div className="graph-card-div container">
                            <div className="row">
                                <div className="col-lg-6 mb-4">
                                    <div className="graph-card m-0 h-100">
                                        <h2 className="graph-head">Exchange Allocation (%)</h2>
                                        {exchangeAllocationGraph?.serise?.length > 0 ? (
                                            <Donutchart key={JSON.stringify(exchangeAllocationGraph)} exchangeAllocationGraph={exchangeAllocationGraph} />
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center loading-container" style={{ height: "auto", flex: "1" }}>
                                                {/* <div className="spinner-container">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <img src={loadingImage} alt="Loading..." className="loading-image" />
                                                </div> */}
                                                <td colSpan="6" style={{ textAlign: "center", padding: "30px 0" }}>
                                                    No Holdings
                                                </td>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-4">
                                    <div className="graph-card m-0 h-100">
                                        <h2 className="graph-head">Sector Allocation (%)</h2>
                                        {sectorAllocationGraph?.serise?.length > 0 ? (
                                            <Donutchart2 key={JSON.stringify(sectorAllocationGraph)} sectorAllocationGraph={sectorAllocationGraph} />
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center loading-container" style={{ height: "auto", flex: "1" }}>
                                                {/* <div className="spinner-container">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <img src={loadingImage} alt="Loading..." className="loading-image" />
                                                </div> */}
                                                <td colSpan="6" style={{ textAlign: "center", padding: "30px 0" }}>
                                                    No Holdings
                                                </td>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-4 mb-lg-0">
                                    <div className="graph-card m-0 h-100">
                                        <h2 className="graph-head">Top 5 Dividends (AED) - YTD</h2>
                                        {top5Dividends.serise && top5Dividends.serise.length > 0 ? (
                                            <HorizontalBarchart key={top5Dividends} top5Dividends={top5Dividends} />
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center loading-container" style={{ height: "auto", flex: "1" }}>
                                                {/* <div className="spinner-container">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <img src={loadingImage} alt="Loading..." className="loading-image" />
                                                </div> */}
                                                <td colSpan="6" style={{ textAlign: "center", padding: "30px 0" }}>
                                                    No Dividends
                                                </td>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-0">
                                    <div className="graph-card m-0 h-100">
                                        <h2 className="graph-head">Top 5 Holdings (AED)</h2>
                                        {top5Holdings.serise && top5Holdings.serise.length > 0 ? (
                                            <Barchart key={top5Holdings} top5Holdings={top5Holdings} />
                                        ) : (
                                            <div className="d-flex justify-content-center align-items-center loading-container" style={{ height: "auto", flex: "1" }}>
                                                {/* <div className="spinner-container">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <img src={loadingImage} alt="Loading..." className="loading-image" />
                                                </div> */}
                                                <td colSpan="6" style={{ textAlign: "center", padding: "30px 0" }}>
                                                    No Holdings
                                                </td>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row m-0">
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="graph-card">
                                <h2 className="graph-head">Exchange Allocation (%)</h2>
                                <Donutchart />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="graph-card">
                                <h2 className="graph-head">Sector Allocation (%)</h2>
                                <Donutchart2 />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="graph-card">
                                <h2 className="graph-head">Top 5 Dividends (AED)</h2>
                                <HorizontalBarchart />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6">
                            <div className="graph-card">
                                <h2 className="graph-head">Top 5 Holdings (AED)</h2>
                                <Barchart />
                            </div>
                        </div>

                    </div> */}
                    </div>
                </div>
                :
                <div className="d-flex justify-content-center align-items-center loading-container">
                    <div className="spinner-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <img src={loadingImage} alt="Loading..." className="loading-image" />
                    </div>
                </div>

            }

        </div>
    )
}